var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41246 3.00175L21.3813 19.9706L21.3831 19.9688L21.3848 19.9706L19.9706 21.3848L16.6137 18.0279C15.3568 18.6142 13.8332 19 12 19C4.408 19 2.12632 12.383 2.10444 12.316L2 12L2.10543 11.684C2.11863 11.6417 3.03404 8.98542 5.62047 7.03469L3 4.41422L4.41246 3.00175ZM15.0867 16.5009L13.2895 14.7037C12.8976 14.8934 12.4599 15 12 15C10.358 15 9 13.642 9 12C9 11.5401 9.10665 11.1024 9.29631 10.7105L7.03632 8.45053C5.26898 9.66593 4.41537 11.3098 4.11657 12C4.61587 13.154 6.67774 17 12 17C13.184 17 14.2067 16.8096 15.0867 16.5009Z",
    fill: "#2E3A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50022 5.26108C10.2611 5.09452 11.0926 5 12 5C19.592 5 21.8737 11.617 21.8956 11.684L22 12L21.8946 12.316C21.8843 12.349 21.3248 13.9731 19.8511 15.6119L18.4594 14.2203C19.2458 13.3296 19.6859 12.4564 19.8834 12C19.3841 10.846 17.3223 7 12 7C11.7475 7 11.5024 7.00866 11.2644 7.02527L9.50022 5.26108Z",
    fill: "#2E3A59"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.d67a7153bc201d039c42343822170567.svg";
export { ForwardRef as ReactComponent };